export const DEFAULT_FRONTEND_TIMEZONE = 'America/New_York';

export const FACEBOOK_SCOPE_PERMISSIONS =
  'ads_management, ads_read, public_profile, email, pages_manage_ads, pages_read_engagement';

export const AUTH0_USER_ID_NAMESPACE = 'https://dojomojo.com/jwt/userId';

export const FB_SDK_VERSION = 'v21.0';
